import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildgeetgovindDescription = (geetgovind: any) => {
  const html = geetgovind?.description ?? geetgovind?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildgeetgovindKeywords = (geetgovind: any) => {
  const parts = [geetgovind?.author, geetgovind?.geetgovindLanguage, geetgovind?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};

export const buildgeetgovindJsonLd = (geetgovind: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = geetgovind?.ogImage || geetgovind?.geetgovindPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildgeetgovindDescription(geetgovind);
  const authorName = geetgovind?.author ? String(geetgovind.author).trim() : "";
  const name = geetgovind?.name ? String(geetgovind.name).trim() : "";
  const inLanguage = geetgovind?.geetgovindLanguage ? String(geetgovind.geetgovindLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "geetgovind",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

